var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "submit-tender clearfix",
      staticStyle: { display: "inline-block" },
      attrs: { id: "warn-tender-update-modal" },
    },
    [
      _c(
        "div",
        {
          staticClass: "reveal",
          attrs: { id: "alertTenderUpdateModal", "data-reveal": "" },
        },
        [
          _c("div", { staticClass: "modal-container" }, [
            _c("p", { staticClass: "confirm-header" }, [
              _vm._v(_vm._s(_vm.$t("vendor.bid.warnUpdate.popupTitle"))),
            ]),
          ]),
          _vm._v(" "),
          _vm.apprErrHint
            ? _c(
                "span",
                { staticClass: "form-error is-visible appr-error-message" },
                [_vm._v("\n      " + _vm._s(_vm.apprErrHint) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row align-right nav_btn" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeAlertTenderUpdateModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("no")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.refreshPage()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("yes")))]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }